angular.module('common.directives.inlineEditDropdown', [])

    .directive("inlineEditDropdown", function ($animate, $timeout, $http, $compile) {
        return ({
            restrict: 'E',
            //scope: {}, // We need to share the scope here, so we update templates passed to directives and bind some elements 
                         // to directive's handlers/properties and some to parent scope's properties
            controller: 'inlineEditDropdownController',
            controllerAs: 'inlineEditDropdownController',
            link: function (scope, element, attrs, parentCtrl) {

                if (!element || !element[0]) return;

                var viewTemplateElement = element.find('view-template');
                var editTemplateElement = element.find('edit-template'); //If edit template is not found - we won't be rendering a button and click handler to switch into 'edit mode'

                if (viewTemplateElement.length === 0) {
                    return; //Do nothing as we don't have view template
                }

                if (editTemplateElement.length > 1) {
                    throw new Error('Edit template must contain single root element.');
                }

                var id = _.random(0, 1000000);
                var inlineEditFormName = `inlineEditForm${id}`;

                //Update view-template's and edit-template's internal elements where necessary
                var editSelectElement = editTemplateElement.find('[ng-model]').first();
                if (editSelectElement) {
                    editSelectElement.attr('id', `editElementRoot${id}`);
                    editSelectElement.attr('ng-blur', `cancelEditDD($event, ${inlineEditFormName})`);    //add so we can handle event when user clicks away from edit control
                    editSelectElement.addClass('inline-dropdown');

                    //Add the call to our internal 'save' handler to switch control's state before the control triggers any change handler assigned to it
                    //to actually save value or do anything else.
                    //But leave any user/caller's assigned handlers so the logic will work that was applied by the control's user
                    var changeHandlerAttr = editSelectElement.attr('ng-change') ? 'ng-change' : (editSelectElement.attr('k-on-change') ? 'k-on-change' : '');
                    if (changeHandlerAttr && changeHandlerAttr.length > 0) {
                        editSelectElement.attr(changeHandlerAttr, `saveDD($event, ${inlineEditFormName}); ${editSelectElement.attr(changeHandlerAttr)}`);
                    }
                }

                var buildElement = function() {
                    var viewTemplate = viewTemplateElement.html();
                    var editTemplate = editTemplateElement ? editTemplateElement.html() : null;

                    //Now wrap the edit template supplied to the directive with additional form and container element markup
                    editTemplate =
                        `<div ng-hide="!isEditModeDD(${id})" class="inline-edit-container">
                        <form name="${inlineEditFormName}">
                            ${editTemplate}
                        </form>
                    </div>`;

                    viewTemplate =
                        `<div ng-hide="isEditModeDD(${id})" class="text-field-container" ng-click="toEditModeDD('${id
                        }')">
                        ${viewTemplate}
                        <a href="" ng-click="toEditModeDD('${id
                        }')" title="{{'Edit value'|translate}}" class="fa fa-pencil edit-text-field-btn" />
                    </div>`;

                    //Finally assemble container element to hold view and edit parts of UI
                    var inlineEditContainerElementTemplate =
                        `<div class="inline-edit-dropdown">${viewTemplate}\n${editTemplate}</div>`;
                    var inlineEditContainerElement =
                        $compile(inlineEditContainerElementTemplate)(
                            scope); //compile against directive's scope, which inherits all the properties from parent scope

                    return inlineEditContainerElement;
                };

                //Finally replace our directive original element with re-compiled and actual content
                element.replaceWith(buildElement());

                //Watch the ng-Model binding path and re-render element if it changes
                if (!scope.watchers) {
                    scope.watchers = [];
                }
                scope.watchers.push(
                    scope.$watch(
                        editSelectElement.attr('ng-model'),
                        function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                //As the model was changed we might want to re-render the UI for our control/directive
                                //TODO: We might want to have watchers here to do actions on model changes
                            }
                        }
                    ));
            }
        });
    })
    .controller('inlineEditDropdownController', function ($element, $scope, $http, $compile, $timeout) {

        //We need the hashmap of the edit flags for all inline edit controls as they don't have isolated scope, but share scope instead with parent scope
        //This is necessary in order to be able to wrap the edit controls into UI blocks using the bindings to parent scope, yet being able to bind to some
        //of our handlers as well. We can't bind one control simultaneously to more than one scope.
        var editFlagsMap = new Map();

        _.extend($scope, {
            getEditModeDD: getEditMode,
            setEditModeDD: setEditMode,
            isEditModeDD: isEditMode,
            saveDD: save,
            toEditModeDD: toEditMode,
            cancelEditDD: cancelEdit
        });

        init();

        function init() {
            $scope.$on("$destroy", function() {
                runAllWatchersDestructor();
            });
        }

        function runAllWatchersDestructor() {
            if ($scope.watchers && $scope.watchers.length > 0) {
                $scope.watchers.forEach(function(wDestructor) {
                    if (wDestructor) {
                        wDestructor();
                    }
                });
            }
        }

        function getEditMode(uid) {
            return editFlagsMap.get(uid.toString());
        }
        function setEditMode(uid, value) {
            editFlagsMap.set(uid.toString(), value);
        }

        function isEditMode(uid) {
            return getEditMode(uid) === true;
        }

        function save(e, form) {
            $scope.$applyAsync(function () {
                setEditMode(getId(form), false);
                setIsBusyOnParentScope(true);
            });
        }

        function setIsBusyOnParentScope(valueToSet) {
            if ($scope.$parent && $scope.$parent.$parent) {
                $scope.$parent.$parent.isBusy = valueToSet;
            }
        }

        function toEditMode(uid) {
            var selector = `#editElementRoot${uid}`;

            setEditMode(uid, true);

            $timeout(function () {
                $scope.$applyAsync(function () {
                    if (selector && selector.length > 0) {
                        var selectElement = $(selector);
                        if (selectElement.length > 0) {
                            selectElement.data('kendoDropDownList').focus();
                            //selectElement.data('kendoDropDownList').open();
                        }
                    }
                });
            });
        }

        function cancelEdit(e, form) {

            e.preventDefault();
            if (form) {
                form.$rollbackViewValue();
            }
            setEditMode(getId(form), false);
        }

        function getId(element) {
            if (element && element.$name) {
                return element.$name.replace('inlineEditForm', '');
            }

            return null;
        }

    });
